export default "/_next/static/images/29a0983ca3a7aca30b82ab9650c950cd.png";